function Button({ text, onClick, color }) {
  const baseClasses = `
    px-6 py-3 sm:px-8 sm:py-4 rounded-xl font-semibold font-[Poppins] text-center 
    text-base sm:text-lg
    border backdrop-blur-sm 
    transition-all duration-300 ease-in-out 
    hover:scale-[1.03] active:scale-95
    focus:outline-none focus:ring-2 focus:ring-offset-0
  `;

  const colorMap = {
    green: `
      text-emerald-400 border-emerald-400/70 
      bg-transparent hover:bg-emerald-400/10 hover:text-emerald-300 
      hover:border-emerald-400 
      hover:shadow-[0_0_20px_rgba(52,211,153,0.45)]
      focus:ring-emerald-500/50
    `,
    red: `
      text-rose-400 border-rose-400/70 
      bg-transparent hover:bg-rose-400/10 hover:text-rose-300 
      hover:border-rose-400 
      hover:shadow-[0_0_20px_rgba(244,63,94,0.45)]
      focus:ring-rose-500/50
    `,
    blue: `
      text-sky-400 border-sky-400/70 
      bg-transparent hover:bg-sky-400/10 hover:text-sky-300 
      hover:border-sky-400 
      hover:shadow-[0_0_20px_rgba(56,189,248,0.45)]
      focus:ring-sky-500/50
    `,
  };

  const colorClasses = colorMap[color] || colorMap.red;

  return (
    <button onClick={onClick} className={`${baseClasses} ${colorClasses}`}>
      {text}
    </button>
  );
}

export default Button;